import axios from "axios";

export default function getGiftOrderSetting() {
  return new Promise((resolve, reject) => {
    axios
      .get(`/campaign/api/admin/gift-setting/option`, {
        params: {
          option: "order",
        },
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
